<template>
  <div class="access-denied">
    <h1>Доступ запрещен</h1>
    <p>У вас нет прав для доступа к этой странице.</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AccessDenied',
};
</script>

<style scoped>
.access-denied {
  text-align: center;
  margin-top: 50px;
}
</style>